import { Component, OnInit } from "@angular/core";
import { ApiService } from "./shared";
import { CompaniesService } from "./companies/companies.service";
import { ProjectsService } from "./projects/projects.service";
import { Router, NavigationEnd } from "@angular/router";
import "../style/app.scss";
import { ApplicationInsightsService } from "./logger/appinsights.service";

enum Categories {
  contentmanagement = 0,
  notifications,
  statitstics,
  accountmanagement
}

@Component({
  selector: "my-app", // <my-app></my-app>
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')]
})
export class AppComponent implements OnInit {
  url = "https://github.com/CaravanStudios/insite-admin-ui";
  postUrls: string[] = ["/", "/posts", "/createpost", "/editpost"];
  alertUrls: string[] = ["/alerts", "/createalert", "/editalert"];
  pollUrls: string[] = ["/polls", "/createpoll", "/pollresponses", "/editpoll"];
  profileUrls: string[] = ["/profiles"];
  notificationUrls: string[] = [
    "/notifications",
    "/createnotification",
    "/editnotification"
  ];
  accountUrls: string[] = [
    "/accounts",
    "/accountdetail",
    "/createaccount",
    "/editaccount",
    "/users",
    "/userdetail",
    "/createuser",
    "/edituser"
  ];
  projectUrls: string[] = ["/projects", "/createproject", "/editproject"];
  companyUrls: string[] = ["/companies", "/createcompany", "/editcompany"];
  bindingsUrls: string[] = ["/bindings"];
  posts: any[];
  errorMessage: any;
  path: string;
  selectedCategory;
  Category = Categories;

  constructor(
    private api: ApiService,
    private companiesService: CompaniesService,
    private projectsService: ProjectsService,
    router: Router,
    private appInsights: ApplicationInsightsService
  ) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.path = event.urlAfterRedirects;
        if (this.postUrls.indexOf(event.urlAfterRedirects) > -1) {
          this.selectedCategory = Categories.contentmanagement;
        } else if (this.alertUrls.indexOf(event.urlAfterRedirects) > -1) {
          this.selectedCategory = Categories.contentmanagement;
        } else if (this.pollUrls.indexOf(event.urlAfterRedirects) > -1) {
          this.selectedCategory = Categories.contentmanagement;
        } else if (this.profileUrls.indexOf(event.urlAfterRedirects) > -1) {
          this.selectedCategory = Categories.contentmanagement;
        } else if (
          this.notificationUrls.indexOf(event.urlAfterRedirects) > -1
        ) {
          this.selectedCategory = Categories.notifications;
        } else if (this.accountUrls.indexOf(event.urlAfterRedirects) > -1) {
          this.selectedCategory = Categories.accountmanagement;
        } else if (this.projectUrls.indexOf(event.urlAfterRedirects) > -1) {
          this.selectedCategory = Categories.accountmanagement;
        } else if (this.companyUrls.indexOf(event.urlAfterRedirects) > -1) {
          this.selectedCategory = Categories.accountmanagement;
        } else if (this.bindingsUrls.indexOf(event.urlAfterRedirects) > -1) {
          this.selectedCategory = Categories.notifications;
        } else {
          this.selectedCategory = -1;
        }
      }
    });
    router.navigate(["/"]);
  }

  ngOnInit() {
    this.projectsService.getProjectList().subscribe();
    this.companiesService.getEmployers().subscribe();
  }

  isActiveTab(pages: string[]) {
    return pages.indexOf(this.path) > -1;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts